import {
  IconPdf,
  IconDoc,
  IconXml,
  IconXlsx,
  IconTxt,
  IconTsv,
  IconTif,
  IconSql,
  IconCsv,
  IconCss,
  IconAi, 
} from '../assets/icon';

const fileIcon = {
  xml: IconXml,
  ai: IconAi,
  pdf: IconPdf,
  tif: IconTif,
  css: IconCss,
  doc: IconDoc,
  csv: IconCsv,
  txt: IconTxt,
  xlsx: IconXlsx,
  tsv: IconTsv,
  sql: IconSql
};

export default fileIcon;
